import { CSSObject } from 'styled-components';
import Button, { ButtonVariation } from './Button';

export default Button;
export type { CSSObject, ButtonVariation };
